import { ListingRightSide } from '@/components/srp/listing-card/styled'

type AutosListingRightSideTypes = {
  children: React.ReactNode
}

export const AutosCrossPromoListingRightSide = ({ children }: AutosListingRightSideTypes) => {
  return <ListingRightSide>{children}</ListingRightSide>
}
